import dayjs from 'dayjs'

const formatFieldworkDate = (date: string | null | undefined): string =>
  date ? dayjs(date).format('D MMM YYYY') : 'N/A'

// endDate is absent while a market is still in field; dayjs(null).format()
// renders the literal "Invalid Date" and dayjs(undefined) renders today.
export const formatFieldworkPeriod = (
  startDate: string | null | undefined,
  endDate: string | null | undefined
): string =>
  `${formatFieldworkDate(startDate)} - ${formatFieldworkDate(endDate)}`
